// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"635ef8ff02c879993911","453":"323b02bfa52f2ba95cdd"}[chunkId] + ".js";
};